<template>
  <span class="inline-block" :class="`text-${color} ${rotate}`">
    <component :is="icon" :width="size" :height="size" :color="color" />
  </span>
</template>

<script>
import PauseIcon from '@/components/icons/IconPause.vue'
import PlayIcon from '@/components/icons/IconPlay.vue'
import CloseIcon from '@/components/icons/IconClose.vue'
import BurgerIcon from '@/components/icons/IconBurger.vue'
import ArrowIcon from '@/components/icons/IconArrow.vue'
import ChevronIcon from '@/components/icons/IconChevron.vue'
import galleryicon from '@/components/icons/IconGallery.vue'
import videoicon from '@/components/icons/IconVideo.vue'
import articleicon from '@/components/icons/IconArticle.vue'
import audioicon from '@/components/icons/IconAudio.vue'
import locationicon from '@/components/icons/IconLocation.vue'
import facebookicon from '@/components/icons/IconFacebook.vue'
import instagramicon from '@/components/icons/IconInstagram.vue'
import youtubeicon from '@/components/icons/IconYoutube.vue'
import linkedinicon from '@/components/icons/IconLinkedin.vue'
import twittericon from '@/components/icons/IconTwitter.vue'
import socialicon from '@/components/icons/IconSocial.vue'
import accommodationicon from '@/components/icons/IconAccommodation.vue'
import servicesicon from '@/components/icons/IconServices.vue'
import subjectsicon from '@/components/icons/IconSubjects.vue'
import exploreallicon from '@/components/icons/IconExploreAll.vue'
import LinkIcon from '@/components/icons/IconLink.vue'

export default {
  name: 'IconBase',
  components: {
    PauseIcon,
    PlayIcon,
    CloseIcon,
    BurgerIcon,
    ArrowIcon,
    ChevronIcon,
    galleryicon,
    videoicon,
    articleicon,
    audioicon,
    locationicon,
    facebookicon,
    instagramicon,
    youtubeicon,
    linkedinicon,
    twittericon,
    socialicon,
    subjectsicon,
    accommodationicon,
    servicesicon,
    exploreallicon,
    LinkIcon
  },

  props: {
    icon: {
      type: String,
      default: 'arrow'
    },
    size: {
      type: String,
      default: '1.5rem'
    },
    color: {
      type: String,
      default: 'currentColor'
    },
    rotate: {
      type: String,
      default: ''
    }
  }
}
</script>
